import React from 'react';
import ContentOverlay from '../ContentOverlay/ContentOverlay';

interface ManufacturerDetailsProps {
    messages: {
        manufacturerDetails: {
            button: () => React.ReactNode;
            title: () => React.ReactNode;
            content: () => React.ReactNode;
        };
    };
    designerIdentifier: string;
}

export const getComponentKey = (seoURLKeyword: string): string | null => {
    const designerName = seoURLKeyword && seoURLKeyword.split('/').pop();
    return designerName ? `manufacturer-${designerName}` : null;
};

function ManufacturerDetails({ messages, designerIdentifier }: ManufacturerDetailsProps) {
    const componentKey = getComponentKey(designerIdentifier);

    return (
        componentKey && <div>
            <ContentOverlay componentKey={componentKey} buttonLabel={messages?.manufacturerDetails?.button()} titleLabel={messages?.manufacturerDetails?.title()} dataTestId={"manufacturer-body"} modifiers={{ buttonModifier: 'manufacturerDetails', textModifier: 'manufacturerDetailsText' }} fallbackContent={messages?.manufacturerDetails?.content()} />
        </div>
    );
}

export default ManufacturerDetails;
